import { generateRandomId } from "Utils";

export const DEFAULT_MESSAGE_DATA = {
  label: "",
  attachments: [],
  id: generateRandomId(),
};
